import "../landing/Landing.css";
import "./Privacy.css";
import "bootstrap/dist/css/bootstrap.min.css";

import WhiteTextLogo from "../../assets/imgs/white-text-logo.svg";
import Menu from "../../assets/imgs/menu.svg";

import CalorieTrackerFeature from "../../assets/imgs/calorie-tracker-feature.svg";
import MealTrackerFeature from "../../assets/imgs/meal-tracker-feature.svg";
import WaterTrackerFeature from "../../assets/imgs/water-tracker-feature.svg";
import CalorieTrackerFeatureMobile from "../../assets/imgs/calorie-tracker-feature-mobile.svg";
import MealTrackerFeatureMobile from "../../assets/imgs/meal-tracker-feature-mobile.svg";
import WaterTrackerFeatureMobile from "../../assets/imgs/water-tracker-feature-mobile.svg";
import CloseButton from "../../assets/imgs/close-button.svg";

import StarIcon from "../../assets/imgs/star-icon.svg";
import NutritionistImage from "../../assets/imgs/nutritionist-image.svg";
import NutritionistImageMobile from "../../assets/imgs/nutritionist-image-mobile.svg";

import DefaultButton from "../../components/DefaultButton/DefaultButton";

import React, { useEffect } from "react";


const Privacy = () => {
  const [openMenu, setOpenMenu] = React.useState(false);

  return (
    <>
      {window.innerWidth <= 768 && openMenu ? (
        <div className="menu">
          <div className="menu__header">
            <div className="menu__header__close">
              <a href="javascript:;" onClick={() => setOpenMenu(false)}>
                <img src={CloseButton} alt="menu" />
              </a>
            </div>
          </div>
          <div className="menu__items">
            <a href="javascript:;" className="menu__item"><p>Início</p></a>
            <a href="javascript:;" className="menu__item"><p>Funcionalidades</p></a>
            <a href="javascript:;" className="menu__item"><p>Contato</p></a>
          </div>
          <div className="menu__actions">
            <DefaultButton
              title="Baixar App"
              style="menu__actions__download"
              onClick={() => {
                window.location.href = "https://apps.apple.com/br/app/lorie/id6596730043?l=en-GB";
              }}
            />
            <DefaultButton
              title="Entrar como Nutricionista"
              onClick={() => {
                window.location.href = "/login";
              }}
              type="secondary"
              style="landing__header__actions__login menu__actions__login"
            />
          </div>
        </div>
      ) : (
        <div className="landing">
          <div className="landing__header">
            <a href="javascript:;" className="landing__header__logo" onClick={() => {
              window.location.href = "/";
            }}>
              <img src={WhiteTextLogo} alt="logo" />
            </a>
            <div className="landing__header__menu">
              <a href="javascript:;" className="landing__header__menu__item" onClick={() => {
                window.location.href = "/";
              }}><p>Início</p></a>
              <a href="javascript:;" className="landing__header__menu__item" onClick={() => {
                window.location.href = "/";
              }}><p>Funcionalidades</p></a>
              <a href="javascript:;" className="landing__header__menu__item" onClick={() => {
                window.location.href = "/";
              }}><p>Contato</p></a>
            </div>
            <div className="landing__header__actions">
              {window.innerWidth >= 768 ? (
                <>
                  <DefaultButton
                    title="Entrar como Nutricionista"
                    onClick={() => {
                      window.location.href = "/login";
                    }}
                    type="secondary"
                    style="landing__header__actions__login"
                    textStyle="landing__header__actions__login__text"
                  />
                  <DefaultButton
                    title="Baixar App"
                    style="menu__actions__download"
                    onClick={() => {
                      window.location.href = "https://apps.apple.com/br/app/lorie/id6596730043?l=en-GB";
                    }}
                  />
                </>
              ) : (
                <a href="javascript:;" onClick={() => setOpenMenu(true)} className="landing__header__menu__button">
                  <img src={Menu} alt="menu" />
                </a>
              )}
            </div>
          </div>
          <div className="landing__privacy">
            <div className="landing__privacy__title">
              <h1>Termos de Uso e Políticas de Privacidade</h1>
            </div>
            <div className="landing__privacy__description">
              <p>Bem-vindo(a) à Lorie! Ao utilizar nosso aplicativo, você concorda com as seguintes políticas de privacidade. Leia atentamente.</p>
            </div>
            <div className="landing__privacy__updatedAt">
              <p>Atualizado em 30 de Agosto de 2026</p>
            </div>
            <div className="landing__privacy__content">
              <div className="landing__privacy__paragraphs">
                <div className="landing__privacy__paragraph">
                  <h3>1 . Descrição da Aplicação</h3>
                  <p>A Lorie é uma aplicação para iOS e Android destinada à gestão de calorias diárias consumidas pelo usuário. As principais funcionalidades incluem:</p>
                  <div className="landing__privacy__bulletPoints">
                    <ul>
                      <li>Gestão de calorias diárias.</li>
                      <li>Recomendação de consumo diário de calorias.</li>
                      <li>Registro de refeições com base em alimentos registrados no sistema.</li>
                      <li>Contagem de calorias, proteínas, sódio, carboidratos, e outros nutrientes.</li>
                    </ul>
                  </div>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>2 . Coleta e Uso de Dados</h3>
                  <p>2.1 Dados Coletados</p>
                  <div className="landing__privacy__bulletPoints">
                    <ul>
                      <li>Nome</li>
                      <li>E-mail</li>
                      <li>Sexo</li>
                      <li>Data de nascimento</li>
                      <li>Dados opcionais: peso e altura (que são utilizados para funcionalidades relacionadas ao consumo diário de calorias individual)</li>
                    </ul>
                  </div>
                  <p>2.2 Uso dos Dados</p>
                  <p>Os dados coletados são armazenados em um banco de dados privado e utilizados apenas para cálculos e geração de gráficos para uso próprio do usuário. Eles também podem ser usados para pesquisas internas da Lorie.</p>
                  <p>2.3 Retenção de Dados</p>
                  <p>A Lorie armazena e retém os dados da conta enquanto o usuário mantiver a conta ativa, para prestar o serviço (login, histórico de refeições, metas, fotos enviadas pelo usuário e status da assinatura). Dados de refeições, fotos de alimentos, informações de perfil e identificadores necessários à assinatura (por exemplo, identificador da conta e recibos processados pela Apple, Google e RevenueCat) são mantidos pelo tempo em que a conta permanecer ativa.</p>
                  <p>Após a exclusão da conta, o acesso do usuário é encerrado e os dados pessoais associados à conta são desativados e anonimizados, de forma que a conta deixa de ser utilizada para identificação ou login. Registros operacionais ou de cobrança tratados pelas lojas (Apple e Google) e pela RevenueCat podem ser retidos por esses provedores conforme as políticas e obrigações legais deles. A Lorie não retém dados pessoais da conta excluída para oferecer o serviço após a exclusão.</p>
                  <p>Se o usuário não solicitar a exclusão, os dados permanecem armazenados enquanto a conta existir. A Lorie não vende dados do usuário e não os utiliza após o encerramento da conta, salvo obrigação legal.</p>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>3 . Pagamentos e Assinaturas</h3>
                  <p>3.1 Assinatura Lorie Premium</p>
                  <p>A Lorie oferece a assinatura opcional Lorie Premium no aplicativo móvel. A assinatura desbloqueia recursos adicionais, como o uso expandido de funcionalidades de inteligência artificial. O plano gratuito continua disponível sem a obrigação de assinar.</p>
                  <p>3.2 Preços e períodos de cobrança</p>
                  <p>A assinatura pode ser contratada nos seguintes planos, com preços vigentes na data desta política:</p>
                  <div className="landing__privacy__bulletPoints">
                    <ul>
                      <li>Mensal: R$ 6,90 por mês, com renovação automática a cada mês.</li>
                      <li>Anual: R$ 59,90 por ano, com renovação automática a cada ano.</li>
                    </ul>
                  </div>
                  <p>Os valores são cobrados na moeda e no preço exibidos pela App Store ou pela Google Play no momento da compra. Impostos aplicáveis podem ser adicionados pela loja. A Lorie pode alterar os preços no futuro; a alteração se aplica a novas assinaturas e, quando exigido, às renovações após aviso.</p>
                  <p>3.3 Processamento do pagamento</p>
                  <p>Os pagamentos da assinatura são processados pela Apple (App Store) ou pelo Google (Google Play), conforme a loja em que o aplicativo foi baixado. A Lorie não coleta nem armazena dados de cartão de crédito. Utilizamos a RevenueCat para gerenciar o status da assinatura junto às lojas. Dados necessários à confirmação da compra, como identificador da conta e recibos da loja, podem ser processados pela Apple, pelo Google e pela RevenueCat, de acordo com as políticas de privacidade desses provedores.</p>
                  <p>3.4 Renovação, cancelamento e acesso</p>
                  <p>A assinatura é renovada automaticamente ao fim de cada período, salvo cancelamento. O usuário pode gerenciar ou cancelar a assinatura a qualquer momento nas configurações da App Store ou da Google Play, ou pela opção de gerenciar assinatura no aplicativo. O cancelamento interrompe a renovação; o acesso Premium permanece até o fim do período já pago. A Lorie não reembolsa períodos já cobrados pelas lojas; pedidos de reembolso devem ser feitos à Apple ou ao Google, conforme as regras de cada loja.</p>
                  <p>3.5 Termos das lojas</p>
                  <p>Compras realizadas na App Store também estão sujeitas aos Termos de Uso da Apple (EULA padrão), disponíveis em https://www.apple.com/legal/internet-services/itunes/dev/stdeula/. Compras na Google Play estão sujeitas aos termos do Google Play. Esta política está disponível em https://lorie.app/privacy-policy.</p>
                  <p>3.6 Licença concedida</p>
                  <p>Os usuários concedem à Lorie a licença para utilizar os dados de suas refeições para fins de cálculos e pesquisas internas.</p>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>4 . Regras e Condutas</h3>
                  <p>Embora a Lorie não tenha regras de conduta específicas, recomendamos fortemente que os usuários:</p>
                  <div className="landing__privacy__bulletPoints">
                    <ul>
                      <li>Não compartilhem suas senhas com terceiros.</li>
                      <li>Relatem  quaisquer bugs ou falhas encontradas através dos canais de contato disponíveis, evitando a exploração desses problemas.</li>
                    </ul>
                  </div>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>5 . Limitação de Responsabilidade</h3>
                  <p>5.1 Responsabilidade</p>
                  <p>O aplicativo Lorie não se responsabiliza por quaisquer danos diretos, indiretos, incidentais, especiais, consequentes ou exemplares, incluindo, mas não se limitando a, perda de dados, falhas no sistema, ou problemas de saúde decorrentes do uso da aplicação ou das recomendações de consumo de calorias fornecidas.</p>
                  <div className="landing__privacy__bulletPoints">
                  </div>
                  <p>5.2 Serviços de Terceiros</p>
                  <p>O aplicativo Lorie pode integrar serviços de terceiros para oferecer funcionalidades adicionais aos usuários, incluindo Apple, Google e RevenueCat para assinaturas. A Lorie não se responsabiliza por quaisquer danos diretos, indiretos, incidentais, especiais, consequentes ou exemplares decorrentes da utilização desses serviços de terceiros, incluindo, mas não se limitando a, falhas no serviço, interrupções, atrasos, erros ou omissões, ou qualquer conteúdo perdido, corrompido ou não entregue. Os usuários são encorajados a revisar e concordar com os termos de serviço e políticas de privacidade dos serviços de terceiros antes de utilizá-los com o aplicativo Lorie.</p>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>6 . Alterações nos Termos de Uso</h3>
                  <p>6.1 Notificação de Alterações</p>
                  <p>Os usuários serão notificados sobre qualquer alteração nos termos de uso através do aplicativo. Na próxima vez que fizerem login, será solicitado que aceitem os novos termos por meio de uma modal que aparecerá.</p>
                  <div className="landing__privacy__bulletPoints">
                  </div>
                  <p>6.2 Aceitação dos Novos Termos</p>
                  <p>Para continuar utilizando a Lorie, os usuários devem ler e aceitar os novos termos clicando no botão de aceite. Caso não aceitem, o uso das funcionalidades da Lorie será bloqueado.</p>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>7 . Exclusão de Dados</h3>
                  <p>O usuário pode solicitar a exclusão dos seus dados a qualquer momento. Há um processo de exclusão, descrito abaixo.</p>
                  <p>7.1 Pelo aplicativo</p>
                  <p>No aplicativo Lorie, acesse Conta (ou Meu perfil) → Gerenciar conta → Deletar conta. Confirme a exclusão permanente. Esse pedido desativa a conta, impede novos logins e anonimiza os dados pessoais associados, conforme a seção de retenção.</p>
                  <p>7.2 Por e-mail</p>
                  <p>O usuário também pode enviar uma solicitação de exclusão de dados para contact@lorie.app, informando o e-mail cadastrado na conta. A Lorie processará o pedido e confirmará pelo mesmo canal.</p>
                  <p>7.3 Assinaturas</p>
                  <p>A exclusão da conta Lorie não cancela automaticamente a assinatura na App Store ou na Google Play. Para interromper cobranças, o usuário deve cancelar a assinatura nas configurações da loja em que comprou, ou pela opção Gerenciar assinatura no aplicativo, antes ou depois de excluir a conta.</p>
                </div>
                <div className="landing__privacy__paragraph">
                  <h3>8 . Contato e Suporte</h3>
                  <p>Para suporte, questões relacionadas aos termos de uso, solicitações de exclusão de dados ou propostas de negócio, os usuários podem entrar em contato com a Lorie através do e-mail: contact@lorie.app.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="landing__footer">
            <div className="landing__footer__logoSection">
              <a href="javascript:;" className="landing__footer__logo">
                <img src={WhiteTextLogo} alt="logo" />
              </a>
              <div className="landing__footer__copyright">
                <p>© 2024 Lorie. Todos os direitos reservados.</p>
              </div>
            </div>
            <a href="javascript:;" className="landing__footer__termsAndPrivacy">
              <p>Termos e privacidade</p>
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Privacy;

Privacy.propTypes = {};
